import { useState } from 'react';

type TechLogoProps = {
  name: string;
  src?: string;
  color?: string;
  className?: string;
  imgClassName?: string;
};

const initialsFor = (name: string) =>
  name
    .split(/[\s.-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('') || name.slice(0, 2).toUpperCase();

const TechLogo = ({ name, src, color = '#ff6a00', className = '', imgClassName = '' }: TechLogoProps) => {
  const [failed, setFailed] = useState(false);
  const isRemote = typeof src === 'string' && /^https?:\/\//i.test(src);

  if (!src || failed || isRemote) {
    return (
      <div
        aria-label={name}
        className={`flex items-center justify-center rounded-lg bg-white text-center font-black leading-none ${className}`}
        style={{ color }}
        title={name}
      >
        <span className="text-[0.72em] tracking-normal">{initialsFor(name)}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      className={imgClassName || className}
      onError={() => setFailed(true)}
      loading="lazy"
      decoding="async"
    />
  );
};

export default TechLogo;
